<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" id="also-by">
<div class="heading heading-with-title heading-without-image" id="also-by-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also by Mairi Chong</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">The Dr Cathy Moreland Mysteries</span></span></b></p>
<p class="subsq also-by-content"><span class="content-external-link">Death by Appointment (Book 1)</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Murder and Malpractice (Book 2)</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Deadly Diagnosis (Book 3)</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Shooting Pains (Book 4)</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Clinically Dead (Book 5)</span></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://geni.us/LethalResuscitation" target="_blank">Lethal Resuscitation (Book 6)</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsobymairichong.vue?1ebdc0a3